import { Component } from 'react';

export default function asyncComponent(importComponent) {
  /**
   * Essa função permite um code splitting na build
   * https://create-react-app.dev/docs/code-splitting/
   * Favorecendo menor carregamento de arquivos desnecessários
   */

  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();
      this.setState({ component });
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}
